import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'


export const initialState = {
    fetching: false,
    error: null,
    shipmentDetailOpen: {},
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.CREATE_SHIPMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.CREATE_SHIPMENT_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.CREATE_SHIPMENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.TOGGLE_SHIPMENT_TRACKING]: (state, action) => {
        const { shipmentId } = action.payload
        return {
            ...state,
            shipmentDetailOpen: {
                ...state.shipmentDetailOpen,
                [shipmentId]: !state.shipmentDetailOpen[shipmentId],
            },
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/logistic/state/list/reducer.js